import 'lightgallery';

export default class {

    constructor() {

        $(".gallery").lightGallery({
            selector: '.gallery-item'
        });

    }

}